{
  "actions": "Действия"
}
